import {
  EMAIL_BROWSER_ADD_ARTICLES,
  EMAIL_BROWSER_ADD_EMAIL,
  EMAIL_BROWSER_CURATION_UNDO,
  BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN,
  BROWSER_REMOVE_ASSET_DRAFT,
  EMAIL_BROWSER,
} from "constants/actionTypes";

import {
  EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST,
  EMAILS_WITHOUT_CAMPAIGNS_LIST,
  ASSET_WITHOUT_CAMPAIGN_DETAILS,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME,
} from "constants/types";
import produce from "immer";
import {
  IAssetItem,
  IAssetsWithoutCampaignsState,
  IAssetWithoutCampaignDetailsState,
  IVersion,
} from "../interfaces";
import { DEFAULT_IMAGE_PLACEHOLDER } from "constants/index";

const emailsWithoutCampaignsInitialState: IAssetsWithoutCampaignsState = {
  data: Array<any>(),
  dashboardData: Array<IAssetItem>(),
  dashboardLoading: false,
  reset: false,
  loading: true,
  page: 0,
  articlesCount: 0,
  assetsCount: 0,
  newlyAddedContact: "",
};

const assetWithoutCampaignDetailsInitialState: IAssetWithoutCampaignDetailsState = {
  draftEditions: Array<IVersion>(),
  sentEditions: Array<IVersion>(),
  loading: false,
  assetName: "",
  assetKeywords: [],
  noKeywords: false,
  assetType: "",
  assetId: "",
  updateName: {
    loading: false,
    success: false,
    fail: false,
  },
  updateKeywords: {
    loading: false,
    success: false,
    fail: false,
  },
  addNewDraft: {
    loading: false,
    success: false,
    fail: false,
  },
  removeDraft: {
    loading: false,
    success: false,
    fail: false,
  },
  updateDraft: {
    loading: false,
    success: false,
    fail: false,
  },
};

export const emailsWithoutCampaignsReducer = produce((draft = emailsWithoutCampaignsInitialState, action: any) => {
  const { type } = action;
  switch (type) {
    //* email adding
    case EMAIL_BROWSER_ADD_EMAIL.ADD:
      draft.loading = true;
      return draft;

    case EMAIL_BROWSER_ADD_EMAIL.ADD_SUCCESS:
      draft.loading = false;
      if (!action.payload?.campaignId) {
        draft.data = [action.payload?.email, ...draft.data];
      }
      return draft;

    case EMAIL_BROWSER_ADD_EMAIL.ADD_FAIL:
      draft.loading = false;
      return draft;

    //* rename any email without campaign
    case EMAIL_BROWSER.SET_EMAIL_NAME:
      const assetIndexToBeUpdated = draft.data.findIndex((email: any) => action.payload.emailId === email.emailId);
      if (assetIndexToBeUpdated !== -1) {
        draft.data[assetIndexToBeUpdated].name = action.payload.emailName;
      }
      return draft;

    //* Remove email from emailBrowser

    case EMAIL_BROWSER.REMOVE_EMAIL:
      if (!action.payload?.campaignId) {
        draft.data = draft.data.filter((item: any) => item.emailId !== action.payload?.emailId);
      }
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.RESET:
      draft.reset = action.payload;
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.LOAD:
      draft.dashboardLoading = true;
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.SUCCESS:
      draft.dashboardLoading = false;
      draft.data = [...action.payload];
      draft.reset = false;
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.FAIL:
      draft.dashboardLoading = false;
      draft.dashboardData = [];
      return draft;

    case BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD_SUCCESS:
      const { edition, assetId } = action.payload;
      const data = draft.data.map((asset: any) => {
        if (asset.asset_id === assetId) {
          asset.editions = [edition, ...asset.editions];
        }
        return asset;
      });
      draft.data = [...data];
      return draft;
    case BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD:
      return draft;
    case BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN.ADD_FAIL:
      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES.SET_PREVIEW:
      const dummyPreviewImg = DEFAULT_IMAGE_PLACEHOLDER;

      let { img, articleId, editionId, articles, total_curated_articles } = action.payload;
      let len = typeof articles === "number" ? 1 : articles.split(",").length;
      let articleCounts = len > 0 ? len : 1;
      draft.data.map((item: any) => {
        if (item.asset_id === articleId) {
          item.editions?.map((elem: any) => {
            if (elem.edition_id === editionId) {
              elem.previewImage = img || dummyPreviewImg;
              elem.recentlyAddedArticles = articles;
              elem.articles_count = total_curated_articles;
              elem.showUndo = true;
            }
          });
        }
      });
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_LIST.RESET:
      draft.loading = false;
      draft.page = 0;
      draft.articlesCount = 0;
      draft.data = [];
      return draft;

    case BROWSER_REMOVE_ASSET_DRAFT.SUCCESS:
      let tbd_assetId = action.payload.assetId;
      let tbd_edition_id = action.payload.editionId;
      draft.data = draft.data.map((item: any) => {
        if (item.asset_id === tbd_assetId) {
          item.editions = item.editions?.filter((elem: any) => elem.edition_id !== tbd_edition_id);
        }
        return item;
      });

      return draft;

    case EMAIL_BROWSER_ADD_ARTICLES.RESET_UNDO:
      let article_Id = action.payload.articleId;
      let edition_Id = action.payload.editionId;
      draft?.data?.map((item: any) => {
        if (item.asset_id === article_Id) {
          item?.editions?.map((elem: any) => {
            if (elem.edition_id === edition_Id) {
              elem.recentlyAddedArticles = "";
              elem.showUndo = false;
            }
          });
        }
      });
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_LIST.RESET_NEWLY_ADDED:
      let asset_Id = action.payload.asset_id;
      let draft_Id = action.payload.draft_id;
      if (draft_Id && asset_Id) {
        draft.data = draft.data.map((element: any) => {
          if (element.asset_id === asset_Id) {
            let drafts = element.editions?.map((item: any) => {
              if (item.edition_id === draft_Id) {
                item.newlyCreated = false;
              }
              return item;
            });
            element.editions = drafts;
          }
          return element;
        });
        // return
      }
      return draft;

    case EMAILS_WITHOUT_CAMPAIGNS_LIST.REMOVE:
      let asset_id = action.payload;
      let newData = [...draft.data];
      newData = newData.filter((item: any) => item.asset_id.toString() !== asset_id);
      draft.data = [...newData];
      return draft;

    case EMAIL_BROWSER_CURATION_UNDO.SUCCESS:
      let tbd_asset_id = action.payload.assetId;
      let tbd_edition_Id = action.payload.versionId;
      let selectedArticles = action.payload.articles;
      let count = selectedArticles.split(",").length;
      draft.data.map((item: any) => {
        if (item.asset_id === tbd_asset_id) {
          item.editions?.map((elem: any) => {
            if (elem.edition_id === tbd_edition_Id) {
              elem.recentlyAddedArticles = selectedArticles;
              elem.showUndo = false;
              elem.articles_count = elem.articles_count - count;
              elem.showUndone = true;
            }
            return elem;
          });
        }
        return item;
      });
      return draft;

    case EMAIL_BROWSER_CURATION_UNDO.RESET:
      let tbr_asset_id = action.payload.assetId;
      let tbr_edition_Id = action.payload.versionId;
      draft.data.map((item: any) => {
        if (item.asset_id === tbr_asset_id) {
          item.editions?.map((elem: any) => {
            if (elem.edition_id === tbr_edition_Id) {
              elem.showUndone = false;
            }
            return elem;
          });
        }
        return item;
      });
      return draft;

    default:
      return draft;
  }
});

export const assetWithoutCampaignDetailsReducer = (
  state = assetWithoutCampaignDetailsInitialState,
  action: any
) => {
  const newState = { ...state };
  const type = action.type;
  switch (type) {
    case ASSET_WITHOUT_CAMPAIGN_DETAILS.LOAD:
      newState.loading = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS.SUCCESS:
      newState.loading = false;
      if (action.payload) {
        newState.assetId = action.payload.assetId;
        newState.assetName = action.payload.assetName;
        newState.assetKeywords = action.payload.assetKeywords;
        if (action.payload.assetKeywords.length === 0) newState.noKeywords = true;
        newState.assetType = action.payload.assetType;
        // let draftEditions = [];
        newState.draftEditions = [...action.payload.editions];
      }
      return newState;

    //* Changing the name and subject for Edition listing
    case ASSET_WITHOUT_CAMPAIGN_DETAILS.SET_DRAFT_NAME:
      const { versionId, subject } = action.payload;
      newState.draftEditions = state.draftEditions.map((li, index) => {
        if (li.version_id === versionId) {
          li.subject = subject;
          li.name = subject;
          newState.updateDraft.success = true;
        }
        return li;
      });
      //* reseting the state
      setTimeout(function () {
        newState.updateDraft.success = false;
      }, 2000);
      return newState;

    case ASSET_WITHOUT_CAMPAIGN_DETAILS.FAIL:
      newState.loading = false;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS.RESET:
      return { ...assetWithoutCampaignDetailsInitialState };

    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME.LOAD:
      newState.updateName.loading = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME.SUCCESS:
      newState.updateName.loading = false;
      newState.updateName.success = true;
      if (action.payload) {
        newState.assetName = action.payload;
      }
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME.FAIL:
      newState.updateName.loading = false;
      newState.updateName.fail = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME.RESET:
      newState.updateName.loading = false;
      newState.updateName.success = false;
      newState.updateName.fail = false;
      return newState;

    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS.LOAD:
      newState.updateKeywords.loading = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS.SUCCESS:
      newState.updateKeywords.loading = false;
      newState.updateKeywords.success = true;
      if (action.keywords) {
        let newKeywords = [...action.keywords];
        if (action.keywords.length === 0) newState.noKeywords = true;
        else newState.noKeywords = false;
        newState.assetKeywords = newKeywords;
      }
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS.FAIL:
      newState.updateKeywords.loading = false;
      newState.updateKeywords.fail = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_KEYWORDS.RESET:
      newState.updateKeywords.loading = false;
      newState.updateKeywords.success = false;
      newState.updateKeywords.fail = false;
      return newState;

    case ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.LOAD:
      newState.addNewDraft.loading = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.SUCCESS:
      newState.addNewDraft.loading = false;
      newState.addNewDraft.success = true;
      if (action.newDraft) {
        let data = [action.newDraft, ...state.draftEditions];
        newState.draftEditions = [...data];
      }
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.FAIL:
      newState.addNewDraft.loading = false;
      newState.addNewDraft.fail = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.RESET:
      newState.addNewDraft.loading = false;
      newState.addNewDraft.success = false;
      newState.addNewDraft.fail = false;
      return newState;

    case ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT.LOAD:
      newState.removeDraft.loading = true;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT.SUCCESS:
      newState.removeDraft.loading = false;
      newState.removeDraft.success = true;
      if (action.payload.versionId) {
        newState.draftEditions = state.draftEditions.filter(
          (item: any) => item.version_id !== action.payload.versionId
        );
      }
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT.FAIL:
      newState.removeDraft.loading = false;
      newState.removeDraft.fail = false;
      return newState;
    case ASSET_WITHOUT_CAMPAIGN_DETAILS_REMOVE_DRAFT.RESET:
      newState.removeDraft.loading = false;
      newState.removeDraft.success = false;
      newState.removeDraft.fail = false;
      return newState;

    default:
      return newState;
  }
};
